import { IMyTeam } from "@/core/interfaces/salesMyTeam.interface";
import {
  ISalesSector,
  ISalesSnapshot,
} from "@/core/interfaces/salesProductivity.interface";
import { ISalesState } from "@/core/interfaces/salesState.interface";
import { ISectorProductivity } from "@/core/interfaces/sectorProductivity.interface";
import { MutationTree } from "vuex";

const mutations: MutationTree<ISalesState> = {
  setSalesLoading(state, payload: boolean) {
    state.isLoading = payload;
  },
  setFetchSectorsLoading(state, payload: boolean) {
    state.isSalesSectorsFetching = payload;
  },
  setSalesSectors(state, payload: ISalesSector[]) {
    state.sectors = payload;
  },
  setSalesSnapshot(state, payload: ISalesSnapshot) {
    state.salesSnapshot = payload;
  },
  setSalesProductivity(state, payload: ISectorProductivity) {
    state.salesProductivity = payload;
  },
  setSalesMyTeam(state, payload: IMyTeam[]) {
    state.salesMyTeam = payload;
  },
  setSalesMyTeamLoading(state, payload: boolean) {
    state.isSalesMyTeamLoading = payload;
  },
};

export default mutations;
